import { MutationTree } from 'vuex';
import { PartnersState } from './types';

export const mutations: MutationTree<PartnersState> = {
    pushPartners:(state, data) => {
        state.partners = state.partners.concat(data)
    },
    setPartners:(state, data) => {
        state.partners = data
    },
    setPartnerItem:(state, data) => {
        state.partnerItem = data
    },
};
